import React, { useEffect, useState } from 'react';
import { BarChart, Bar, Cell, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { getChart } from '../services/ api_services';
import { isArray } from 'lodash';



function Chart({daychart, isUri, refreshKey}) {
    
const stateType = [
    { name: "오늘", value: "today" },
    { name: "일주일", value: "week" },
    { name: "30일", value: "30" },
  ];

  const [selectedState, setSelectedState] = useState(stateType[0].name);
  const [chartdata, setChartdata] = useState([]);

  const fetchChart = async () => {
    try {
      const params = { daychart: daychart}
      console.log(" ~fetchChart~ responseChart", params);
      const responseChart = await getChart(params);
      console.log(" ~fetchChart~ responseChart", responseChart);

      const groupedList = [];
      responseChart.data.forEach((item, index) => {
        console.log(item)

        if (isUri) {
          groupedList.push({
            date: item[0],
            iphone: item[2],
            iphoneErr: item[3],
            android: item[4],
            androidErr: item[5]
          })
        } else {
          groupedList.push({
            date: item[0],
              정상: item[2],
              주의: item[3],
              높음: item[4],
              매우높음: item[5]
          })
        }
      }
    )

    //   const groupedList = [];
    //   responseChart.data.forEach((item, index) => {
    //     if (groupedList && isArray(groupedList) && !groupedList.find(i => i.date === item.inst_dt)) {
    //       groupedList.push({
    //         date: item.inst_dt,
    //         정상: item.insp_lvl === "1" ? item.count : 0,
    //         주의: item.insp_lvl === "2" ? item.count : 0,
    //         높음: item.insp_lvl === "3" ? item.count : 0,
    //         매우높음: item.insp_lvl === "4" ? item.count : 0
    //       });
    //     }
    //     else {
    //       if (item.insp_lvl === "1") {
    //         groupedList.find(i => i.date === item.inst_dt).정상 += item.count;
    //       } if (item.insp_lvl === "2") {
    //         groupedList.find(i => i.date === item.inst_dt).주의 += item.count;
    //       } if (item.insp_lvl === "3") {
    //         groupedList.find(i => i.date === item.inst_dt).높음 += item.count;
    //       } if (item.insp_lvl === "4") {
    //         groupedList.find(i => i.date === item.inst_dt).매우높음 += item.count;
    //       }
    //     }
    //   })
    //  console.log("🚀 ~ groupedList ~ groupedList:", groupedList)


      setChartdata(groupedList);
      console.log("🚀 ~ ~ ~ chartdata:", chartdata);
    }
    catch (e) {
      console.log("e===>", e);
    }

  }

  useEffect(() => {
    setSelectedState(stateType.find((item) => item.value === daychart).name);
    fetchChart();
    console.log("🚀 ~ ~ e.value:", daychart);
  }, [daychart, refreshKey]);

  return (
    <div className='p-2'>
      <div
        onChange={(e) => {
          // setSelectedState(stateType.find((item) => item.value === daychart).name);
          // console.log("🚀 ~ ~ e.value:", item.value);

          // setRequest((preVal) => {
          //     return {
          //         ...preVal,
          //         stateType: e.value,
          //     };
          // });
      }}
      >
        {/* {selectedState} */}
        </div>
      <div className='flex justify-center'>
        <BarChart 
          data={chartdata}
          width={1000}
          height={300}
          fontSize={13}
          margin={{
            top: 20,
            right: 30,
            left: 20,
            bottom: 5,
          }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="date" />
          <YAxis />
          <Tooltip />
          <Legend />
          {isUri?
          (<><Bar dataKey="iphone" stackId="a" fill="#A8E6CF" />
          <Bar dataKey="iphoneErr" stackId="a" fill="#fdb9c0" />
          <Bar dataKey="android" stackId="b" fill="#B2EBF2" />
          <Bar dataKey="androidErr" stackId="b" fill="#FFD3B6" /></>)
          :
          (<><Bar dataKey="정상" stackId="a" fill="#faeded" />
          <Bar dataKey="주의" stackId="a" fill="#fae1eb" />
          <Bar dataKey="높음" stackId="a" fill="#fad4eb" />
          <Bar dataKey="매우높음" stackId="a" fill="#fac3ed" /></>)
          }
        </BarChart>
      </div>
      
    </div>
  );
}

export default Chart;